<template>
  <div class="dropdown">
    <button :data-label="$te(`${infos.label}.label`) ? $t(`${infos.label}.label`) : infos.label" class="btn btn--default dropbtn" v-bind:class="btnClass" @click="openDropdown()" :disabled="disabled">
      <i class="dropbtn" v-bind:class="infos.icon"></i>
    </button>
    <div :id="infos.identifier" class="dropdown-content u-textLeft">
      <ul>
        <li v-for="option in infos.options" :key="option">
          <a v-if="optionIsObject(option)" v-bind:class="{ 'is-active': currentOption === option.value  }" @click="changeOption(option.value)">
            {{ $te(`${option.label}.label`) ? $t(`${option.label}.label`) : option.label }}
          </a>
          <a v-else v-bind:class="{ 'is-active': currentOption === option  }" @click="changeOption(option)">
            {{ $te(`${option}.label`) ? $t(`${option}.label`) : option }}
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import { isObject } from 'lodash'

  export default {
    data: () => ({
      currentOption: null
    }),
    props: {
      infos: {
        type: Object,
        required: true
      },
      defaultOption: {
        type: [String, Number],
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      showHintDisabled: {
        type: Boolean,
        default: true
      }
    },
    created () {
      this.currentOption = this.defaultOption

      if (this.infos.sizeBtn === undefined) {
        this.infos.sizeBtn = 'btn--lg'
      }
    },
    mounted () {
      const closeAll = this.closeAll
      window.onclick = function (event) {
        if (!event.target.matches('.dropbtn')) {
          closeAll()
        }
      }

      this.changeOption(this.currentOption)
    },
    methods: {
      changeOption (option) {
        this.$emit('change', option)
        this.currentOption = option
      },
      closeAll () {
        const dropdowns = document.getElementsByClassName('dropdown-content')

        for (let i = 0; i < dropdowns.length; i++) {
          const openDropdown = dropdowns[i]

          if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show')
          }
        }
      },
      openDropdown () {
        this.closeAll()
        document.getElementById(this.infos.identifier).classList.toggle('show')
      },
      optionIsObject (option) {
        return isObject(option)
      }
    },
    computed: {
      btnClass () {
        const btnClass = {
          'hint hint--right': !(!this.showHintDisabled && this.disabled)
        }

        let sizeBtn = 'btn--lg'
        if (this.infos.sizeBtn !== undefined) {
          sizeBtn = this.infos.sizeBtn
        }

        btnClass[sizeBtn] = true

        return btnClass
      }
    }
  }
</script>

<style scoped lang="sass">
  i
    color: #7872ff

  ul
    list-style: none
    margin: 0
    padding: 4px 0

  .dropdown
    position: relative
    display: inline-block

  .dropdown-content
    display: none
    position: absolute
    background-color: #fff
    min-width: 160px
    box-shadow: 0 2px 6px 1px rgba(0, 0, 0, 0.08)
    font-size: 14px
    color: #333333
    border: 1px solid #ddd
    border-radius: 3px
    cursor: pointer
    padding: 4px 0
    margin-top: 4px
    z-index: 2147483647

    li
      display: block
      padding: 0 4px

      &:not(:last-child)
        margin-bottom: 2px

    a
      color: #333333
      text-decoration: none
      display: block
      border-radius: 3px
      padding: 6px 12px

      &.is-active
        background-color: #7872ff
        color: #fff

      &:not(.is-active):hover
        background-color: #f2f2f2

  .show
    display: block
</style>



// WEBPACK FOOTER //
// ButtonDropdown.vue?7f08e019